/* ControlSystemPage — §49-50 */
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { controlApi } from "../lib/controlApi";
import { STATUS_STYLE } from "../ControlApp";
import { ChevronLeft, Loader2, RefreshCw } from "lucide-react";

const COMPONENT_LABELS = {
  portal: "Portal", database: "Base de datos", editorial_engine: "Motor editorial",
  scheduler: "Scheduler", scraping_engine: "Scraping", ai_provider: "IA",
  facebook: "Facebook", instagram: "Instagram", media_storage: "Almacenamiento",
  publication_queue: "Cola de publicación",
};

export default function ControlSystemPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      // Reuse system health via control/dashboard which already includes components + we call directly:
      const dash = await controlApi.dashboard();
      // Fetch full details:
      const url = `${process.env.REACT_APP_BACKEND_URL || ""}/api/system/health`;
      const t = localStorage.getItem("spc.access_token");
      const r = await fetch(url, { headers: { Authorization: `Bearer ${t}` } });
      const full = await r.json();
      setData({ dash, full });
    } catch { /* noop */ } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="p-6 text-textgray text-sm flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Cargando…</div>;
  const components = (data && data.full && data.full.components) || {};
  return (
    <div className="p-4 space-y-3" data-testid="spc-system">
      <div className="flex items-center gap-2">
        <Link to="/control/more" className="text-textgray"><ChevronLeft className="w-4 h-4" /></Link>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-[0.35em] text-textgray">Sistema</div>
          <div className="font-serif text-xl font-bold text-blueblack">Componentes</div>
        </div>
        <button onClick={load} className="w-10 h-10 flex items-center justify-center border border-softblue bg-white">
          <RefreshCw className="w-4 h-4" />
        </button>
      </div>
      <ul className="border border-softblue bg-white divide-y divide-softblue">
        {Object.entries(COMPONENT_LABELS).map(([key, label]) => {
          const c = components[key] || { status: "unknown", message: "—" };
          const s = STATUS_STYLE[c.status] || STATUS_STYLE.unknown;
          return (
            <li key={key} className="p-3 flex items-start gap-3">
              <span className={`w-2 h-2 rounded-full mt-2 ${s.dot}`} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-bold text-blueblack">{label}</div>
                  <div className={`text-[10px] uppercase tracking-widest font-bold ${s.text}`}>{s.label}</div>
                </div>
                <div className="text-xs text-textgray mt-0.5 break-words">{c.message || "—"}</div>
                {c.last_check_at && (
                  <div className="text-[10px] text-textgray mt-0.5">
                    Último chequeo: {new Date(c.last_check_at).toLocaleString("es-AR", { timeZone: "America/Argentina/Ushuaia" })}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
